export default __webpack_public_path__ + "static/media/Montserrat-BlackItalic.bb62ac42.ttf";